import { Box } from '@mui/material';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VOICE_COMMAND_DOCS } from '../../../data/voiceCommandsDocs';
import { CommonIcon } from '../../common/CommonIcon';
import { SegmentedChipBar, type SegmentedChipItem } from '../../common/SegmentedChipBar';
import { voiceCommandsShortTabLabel } from './voiceCommandsDocsShared';

interface VoiceCommandsDocsTabBarProps {
  activeId: string;
  onSelect: (id: string) => void;
}

export const VoiceCommandsDocsTabBar: FC<VoiceCommandsDocsTabBarProps> = ({ activeId, onSelect }) => {
  const { i18n } = useTranslation();
  const items: SegmentedChipItem[] = useMemo(
    () =>
      VOICE_COMMAND_DOCS.map((c) => ({
        id: c.id,
        label: voiceCommandsShortTabLabel(c),
        icon: <CommonIcon icon={c.icon} type="filled" size={14} color="var(--tg-theme-text-color)" />,
      })),
    [i18n.language]
  );

  return (
    <Box sx={{ px: 2, pt: 1.5, pb: 1.25, flexShrink: 0 }}>
      <SegmentedChipBar items={items} activeId={activeId} onChange={onSelect} />
    </Box>
  );
};
